module.exports = __webpack_public_path__ + "media/images/shapes/curves/curve-6-8c9752ca923b94898fa4c1efb5ee188e.svg";